// extracted by mini-css-extract-plugin
export var downArrow = "_j3-0";
export var infoTooltipIcon = "_j3-3";
export var label = "_j3-1";
export var optionCard = "_j3-4";
export var upArrow = "_j3-2";